/**
 *
 * Asynchronously loads the component for AssetsInventoryPage
 *
 */

import { lazyLoad } from 'utils/loadable';

export const AssetsInventoryPage = lazyLoad(
  () => import('./index'),
  module => module.AssetsInventoryPage,
);
